import {
  createExternalRouteRef,
  createRouteRef,
} from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();
export const dashboardsRootRouteRef = createRouteRef();
export const devToolsRootRouteRef = createRouteRef();
export const exploreRootRouteRef = createRouteRef();
export const userSettingsRootRouteRef = createRouteRef();
// Bound to the scaffolder templates sub-page by the app override, not to a page in this plugin
export const scaffolderTemplatesRouteRef = createRouteRef();
export const supportRootRouteRef = createRouteRef();
export const taskExplorerRootRouteRef = createRouteRef();
export const agentsRootRouteRef = createRouteRef();

/**
 * External route refs for linking to external plugins.
 */
export const decisionMatrixExternalRouteRef = createExternalRouteRef({});

export const qetaExternalRouteRef = createExternalRouteRef({});

export const scaffolderExternalRouteRef = createExternalRouteRef({});

export const catalogImportPluginExternalRouteRef = createExternalRouteRef({});

export const techRadarExternalRouteRef = createExternalRouteRef({});

export const techSpotEventCalendarExternalRouteRef = createExternalRouteRef({});

export const contributeRootRouteRef = createRouteRef();

export const contributeExternalRouteRef = createExternalRouteRef({});
